import { render, staticRenderFns } from "./preference-widget-privacy-policy-card.vue?vue&type=template&id=bcf5ecbe"
import script from "./preference-widget-privacy-policy-card.vue?vue&type=script&lang=js"
export * from "./preference-widget-privacy-policy-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports